import api from './../../fetch/api.js'
import * as types from './../types.js'

const state = {
    newMsg: {
        data: [],
        msg: {}
    }
}

const actions = {
    getNewApi({
        commit
    }) {
        api.newApi().then((res) => {
            commit(types.GET_NEW, res);
        })
    }
}

const getters = {
    newMsg: state => state.newMsg
}

const mutations = {
    [types.GET_NEW](state, res) {
        state.newMsg = {
            ...state.newMsg,
            data: res.data.data
        };
    }
}

export default {
    state,
    actions,
    getters,
    mutations
}